import Carousel, { Modal, ModalGateway } from "react-images";

const CarouselWindow = ({ images, setOpen, open, curIndex }) => {
  return (
    <ModalGateway>
      {open ? (
        <Modal onClose={() => setOpen(false)}>
          <Carousel
            views={images.map((img) => ({ src: img }))}
            currentIndex={curIndex}
          />
        </Modal>
      ) : null}
    </ModalGateway>
  );
};

export default CarouselWindow;
